import { graphql } from '@/generated/gql';

export const SAVINGS_LIST_QUERY = graphql(/* GraphQL */ `
  query SavingsList($query: SavingQueryInput) {
    savings(query: $query) {
      id
      name
      description
      status
      savingType
      currency
      baselinePrice
      newPrice
      baselineQuantity
      newQuantity
      validFrom
      validTo
      multiYearSaving
      createdAt
      updatedAt
      fkBuyer
      fkSupplier
      fkCommodityGroup
      freeTextCommodity
      fkProcurementOrganization
      fkOrganization
      fkPurchasingGroup
      fkAccountingArea
      fkUnit
      originalPriceQuantity
      newPriceQuantity
      reductionType
      costAllocation {
        distributionType
        allocationValue
        fkAccountAssignmentCategory
        fkAccountAssignment
        fkGeneralLedgerAccount
      }
      sourceReferences {
        fkSourceSystem
        isPrimary
        sourceContext
        sourceReference
        sourceReferenceItem
        synchronizedAt
      }
    }
  }
`);
